import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const Section = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  marginTop: "32px",
  flexDirection: "column",
  gap: "16px",
  padding: " 0  96px 48px 96px",
  [theme.breakpoints.down("lg")]: {
    padding: "16px 24px",
  },
}));
export const HeadText = styled(Typography)(({ theme }) => ({ props }) => ({
  fontSize: "32px",
  fontWeight: "700",
  color: "#000",
  lineHeight: "30px",
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
}));
export const ContactBox = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  gap: "24px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
export const ContactLink = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  gap: "32px",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "20px",
  },
}));
export const ContactLinkBox = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  marginTop: "68px",
  [theme.breakpoints.down("sm")]: {
    // marginTop: '32px',
    // gap: '4px'
  },
}));
export const ContactInformation = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0px",
  width: "65%",
  background: "#0056D2",
  borderRadius: "10px",
  padding: " 48px 48px 24px",
  boxSizing: "border-box",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "24px 16px",
  },
}));
export const ContactInformationText = styled(Box)(
  ({ theme }) =>
    ({ props }) => ({
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    })
);
export const ContactText = styled("p")(({ theme }) => ({ props }) => ({
  fontSize: "16px",
  fontWeight: "400",
  color: "#FFFFFF",
  lineHeight: "21px",
  margin: "0",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));
export const ContactTextTel = styled("p")(({ theme }) => ({ props }) => ({
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "-4px",
  lineHeight: "0",
  color: "#FFFFFF",
  marginLeft: "10px",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
  [theme.breakpoints.down("xs")]: {
    textAlign: "center",
  },
}));
export const ContactTextImg = styled("div")(({ theme }) => ({ props }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  // gap: "16px",
  justifyContent: "space-around",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
    gap: "8px",
    justifyContent: "center",
  },
  [theme.breakpoints.down("xs")]: {
    justifyContent: "space-evenly",
  },
}));
export const ContactForm = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  gap: "24px",
  borderRadius: "10px",
  width: "100%",
  boxSizing: "border-box",
  alignItems: "space-between",
  flexWrap: "wrap",
  justifyContent: "center",
}));
export const FormContact = styled(Box)(({ theme }) => ({ props }) => ({
  width: "40%",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
  },
}));
export const FormContactMulti = styled(Box)(({ theme }) => ({ props }) => ({
  width: "84%",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
  },
}));
export const FormButooon = styled(Box)(({ theme }) => ({ props }) => ({
  width: "150px",
  padding: "10px 48px",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
    padding: "10px",
  },
}));
export const ContactImg = styled(Box)(({ theme }) => ({ props }) => ({
  display: "flex",
  gap: "12px",
  boxSizing: "border-box",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "64px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "30px",
  },
}));
export const Img = styled("img")(({ theme }) => ({ props }) => ({
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  [theme.breakpoints.down("md")]: {
    width: "30px",
    height: "30px",
  },
}));
export const ImgDown = styled("img")(({ theme }) => ({ props }) => ({
  width: "40%",
  margin: 0,
  [theme.breakpoints.down("md")]: {
    width: "130px",
  },
}));
